<template>
	<div class="cash">
		<!-- <van-nav-bar v-if="!isWeChat()" fixed placeholder :title="$route.meta.title" left-arrow /> -->
		<div class="wrap">
			<div class="wrap_left">可提现金额：¥ {{ price }}</div>
		</div>
		<div class="wrap_box">
			<div class="wrap_left">提现金额</div>
			<div class="wrap_money">
				¥
				<input v-model="txCost" class="wrap_box_text" name="money" type="number" />
			</div>
		</div>
		<div class="wrap_style">
			<div class="wrap_style_title">提现方式</div>
			<div class="">
				<!-- <div @click="onChangeType" class="stylewei" data-type="1">
					<div class="stylewei_left">
						<img class="stylewei_img2" src="@/assets/alipay.png" />
						<div class="stylewei_text">提现到支付宝</div>
					</div>
					<van-icon name="passed" :color="color" size="20" v-if="type === 1" />
				</div>
				<div @click="onChangeType" class="stylewei" data-type="2">
					<div class="stylewei_left">
						<img class="stylewei_img2" src="@/assets/weixin.png" />
						<div class="stylewei_text">提现到微信</div>
					</div>
					<van-icon name="passed" :color="color" size="20" v-if="type === 2" />
				</div> -->
				<div @click="onChangeType" class="stylewei" data-type="3">
					<div class="stylewei_left">
						<img class="stylewei_img2" src="@/assets/yinlian@2x.png" />
						<div class="stylewei_text">提现到银行卡</div>
					</div>
					<van-icon name="passed" :color="color" size="20" v-if="type === 3" />
				</div>
				<div class="wrap_style2 wrap_zhi2">
					<div class="wrap_write">
						<div class="write_left">姓名</div>
						<input class="write_inp" v-model="name" placeholder="请填写姓名" placeholderStyle="color:#ccc;"
							type="text" />
					</div>
					<div class="wrap_write">
						<div class="write_left">账号</div>
						<input class="write_inp" v-model="account" placeholder="请填写账号" placeholderStyle="color:#ccc;"
							type="text" />
					</div>
					<div class="wrap_write" v-if="type === 3">
						<div class="write_left">开户行</div>
						<input class="write_inp" v-model="bank" placeholder="请填写开户行" placeholderStyle="color:#ccc;"
							type="text" />
					</div>
				</div>
			</div>
		</div>
		<div class="wrap_btn">
			<button class="wrap_btnin1" :style="`background:{{color}}`" @click="formSubmit">
				提现
			</button>
		</div>
		<div class="wrap_info">
			<div>详细说明</div>
			<div>提现门槛为{{ settings.txMoney }}元</div>
			<div>提现手续费为{{ settings.txSxf || settings.txRate }}%</div>
			<div v-if="sxf != null">本次提现将扣除手续费¥{{ sxf }}</div>
			<div v-if="sjCost != null">本次提现实际到账金额¥{{ sjCost }}</div>
		</div>
	</div>
</template>

<script>
	import request from "@/utils/request";
	import {
		isWeChat
	} from "@/utils/common";
	import {
		showToast,
		NavBar as VanNavBar,
		Icon as VanIcon,
	} from "vant";

	export default {
		components: {
			VanNavBar,
			VanIcon,
		},
		watch: {
			txCost(e) {
				var a = this.settings.txRate,
					n = e * (a / 100),
					o = e - n;
				(o = o.toFixed(2)), (n = n.toFixed(2));
				this.txCost = e;
				this.sxf = n;
				this.sjCost = o;
			}
		},
		data() {
			return {
				type: 3,
				txCost: "0.00",
				price: "0.00",
				color: "#fd8238",
				cashs: [],
				isLoading: false,
				settings: {},
				sxf: 0,
				sjCost: 0,
				name: "",
				account: "",
				bank: "",
				source: "commission",
				sellerId: 0,
				username: '',
				password: ''
			};
		},
		mounted() {
			console.log('isWeChat', this.$route.query);
			if (this.$route.query.token) {
				localStorage.setItem("token", this.$route.query.token)
			}

			const {
				source,
				sellerId,
				username,
				password
			} = this.$route.query;
			if (source) {
				this.source = source;
			}
			if (sellerId) {
				this.sellerId = sellerId;
			}
			if (username) {
				this.username = username;
			}
			if (password) {
				this.password = password;
			}
			request
				.get("", {
					params: {
						do: this.source === "commission" ? "CountCommission" : "TxMoney",
						seller_id: sellerId,
						username: username,
						password: password
					},
				})
				.then((result) => {
					this.settings = result.data.settings;
					if (this.source === "commission") {
						this.price = result.data.ktx;
					} else {
						this.price = result.data.money;
						this.settings.txRate = result.data.settings.txSxf;
						this.settings.txMoney = result.data.settings.zdMoney;
					}
				})
				.catch(console.error);
		},
		methods: {
			isWeChat,
			onChangeType(e) {
				console.log(e);
				const {
					type
				} = e.target.dataset;
				this.type = +type;
			},
			async formSubmit() {
				try {
					const {
						name,
						account,
						bank,
						txCost,
						sjCost,
						type,
						sellerId,
						username,
						password
					} = this;
					const {
						data
					} = await request.get("", {
						params: {
							do: this.source === "commission" ? "Yjtx" : "SaveTxApply",
							name,
							account,
							bank,
							tx_cost: txCost,
							sj_cost: sjCost,
							type,
							seller_id: sellerId,
							username: username,
							password: password
						},
					});
					if (data.state) {
						showToast({
							type: "success",
							message: "申请成功",
							duration: 2000,
						});
					} else {
						showToast({
							type: "error",
							message: "申请失败",
							duration: 2000,
						});
					}
				} catch (e) {
					console.log(e);
				}
			},
			onChat(chatId) {
				if (this.isWechat()) {
					/* eslint-disable no-undef */
					wx.miniProgram.navigateTo({
						url: "/pages/info/chat?id=" + chatId
					});
				} else {
					this.$router.push({
						name: "cash/chat",
						query: {
							chatId
						},
					});
				}
			},
			async getCashs() {
				try {
					const {
						data
					} = await request.get("", {
						params: {
							do: "Cashs",
						},
					});
					this.cashs = data;
				} catch (e) {
					console.log(e);
				}
			},
		},
	};
</script>
<style lang="less">
	body {
		background-color: #f1f1f1;
	}

	.cash {
		.wrap_font {
			font-size: 13px;
		}

		.butt {
			background: #41b0ff;
		}

		.wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 35px;
			padding: 0px 15px;
		}

		.wrap_left {
			color: #606060;
		}

		.wrap_right {
			color: #ff6161;
			text-decoration: underline;
		}

		.wrap_box {
			background-color: white;
			padding: 10px 15px;
		}

		.wrap_box_text {
			margin-left: 7.5px;
		}

		.wrap_money {
			font-size: 21rpx;
			color: #333;
			margin-top: 3.5px;
			display: flex;
			align-items: center;
		}

		.wrap_money input {
			width: 250px;
			height: 35px;
			border: none;
		}

		.wrap_style {
			background-color: white;
			border-bottom: 0.5px solid #eeeeee;
			padding: 0px 15px;
			margin-top: 10px;
		}

		.wrap_style3 {
			height: 0px;
			overflow: hidden;
			transition: 0.3s;
		}

		.wrap_style2 {
			height: 0;
			overflow: hidden;
			margin-top: -150px;
			transition: 0.3s;
		}

		.wrap_style_title {
			color: #606060;
			height: 35px;
			border-bottom: 0.5px solid #eeeeee;
			line-height: 35px;
		}

		.stylewei {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 45px;
			border-bottom: 0.5px solid #eeeeee;
		}

		.stylewei_img {
			width: 25px;
			height: 25px;
			margin-right: 7.5px;
		}

		.stylewei_img2 {
			width: 25px;
			height: 21.5px;
			margin-right: 7.5px;
		}

		.stylewei_right {
			border: 0.5px solid #666;
			border-radius: 50%;
			height: 15px;
			width: 15px;
		}

		.stylewei_text {
			color: #333;
		}

		.stylewei_left {
			display: flex;
			align-items: center;
		}

		.wrap_write {
			display: flex;
			align-items: center;
			height: 45px;
			border-bottom: 0.5px solid #eeeeee;
		}

		.write_left {
			width: 30%;
			color: #606060;
		}

		.write_inp {
			width: 70%;
			color: #333;
			border: none;
		}

		.wrap_zhi2 {
			height: auto;
			background-color: white;
			border-top: 0.5px solid #eeeeee;
			border-bottom: 0.5px solid #eeeeee;
			padding: 0px 15px;
			margin-top: 0px;
			transition: 0.3s;
		}

		.wrap_zhi {
			height: auto;
			opacity: 1;
			margin-top: 0px;
		}

		.wrap_ka2 {
			height: auto;
			background-color: white;
			border-top: 0.5px solid #eeeeee;
			border-bottom: 0.5px solid #eeeeee;
			padding: 0px 15px;
			margin-top: 0px;
			transition: 0.3s;
		}

		.wrap_ka {
			height: auto;
			opacity: 1;
			margin-top: 0px;
		}

		.wrap_btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 15px;
			margin-bottom: 15px;
			padding: 0px 15px;
		}

		.wrap_btnin {
			width: 100%;
			color: white;
			background-color: #cccccc;
			border: none;
		}

		.wrap_btnin1 {
			width: 100%;
			color: white;
			background-color: #f66926;
			border: none;
			height: 42px;
		}

		.wrap_info {
			font-size: 12px;
			color: #999;
			line-height: 23px;
			padding: 0px 15px;
		}
	}
</style>